import React from 'react'
import { NoPermissionsPage as VendNoPermissionPage } from '@vend/react-utilities'
import { reactular } from '@vendhq/reactular'

export const NoPermissionsPage = ({ ...props }) => {
  return <VendNoPermissionPage {...props} />
}

export const NoPermissionsPageComponent = reactular(NoPermissionsPage, [
  'callToAction',
  'copy',
  'heading',
  'backgroundColor',
])
